<template>
  <div class="about">
    <div class="about-content">
      <div class="about-text">
        <h3>Our Story</h3>
        <p>GO Count Object -Thing Counter was born in 2024, stemming from a simple need of our team members: a clean yet powerful tool to track the frequency of everyday items and activities. Applications on the market were either too complex or lacked functionality, so we decided to develop our own counting tool that truly meets users' needs.</p>
        
        <h3>Our Mission</h3>
        <p>We are committed to providing the simplest, most intuitive data recording tools to help users develop good habits, track personal progress, and achieve goals. We believe that simple tools often bring about the biggest changes.</p>
        
        <h3>Our Team</h3>
        <p>Our team consists of a group of professionals who love technology and focus on user experience. Each member is dedicated to creating the highest quality products, ensuring that GO Count can meet various user needs, and continuously improving and innovating based on user feedback.</p>
      </div>
    </div>
    
    <div class="testimonials">
      <h3>User Reviews</h3>
      
      <div class="testimonial-grid">
        <div class="testimonial">
          <div class="stars">★★★★★</div>
          <p class="quote">"This is the best counting app I've ever used, simple to use with complete features."</p>
          <p class="author">— Mr. Zhang, Fitness Enthusiast</p>
        </div>
        
        <div class="testimonial">
          <div class="stars">★★★★★</div>
          <p class="quote">"It helped me develop a good habit of drinking water every day, highly recommended!"</p>
          <p class="author">— Ms. Li, Office Worker</p>
        </div>
        
        <div class="testimonial">
          <div class="stars">★★★★☆</div>
          <p class="quote">"The data statistics feature is very practical, allowing me to clearly see my progress."</p>
          <p class="author">— Wang, College Student</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutPage'
}
</script>

<style scoped>
.about {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
}

.about-content {
  display: flex;
  flex-direction: column;
  margin: 50px 0;
}

.about-text {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
}

h3 {
  color: #4a9ad8;
  margin: 30px 0 15px;
  font-size: 1.6rem;
}

.testimonials {
  margin: 60px 0;
  background-color: #e8f4fc;
  padding: 40px;
  border-radius: 10px;
}

.testimonial-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  margin-top: 30px;
}

.testimonial {
  background-color: #ffffff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
}

.testimonial:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
}

.stars {
  color: #4a9ad8;
  font-size: 1.4rem;
  margin-bottom: 15px;
}

.quote {
  font-style: italic;
  margin-bottom: 15px;
  font-size: 1.1rem;
  line-height: 1.6;
  position: relative;
}

.quote::before {
  content: '"';
  font-size: 2.5rem;
  color: #e8f4fc;
  position: absolute;
  left: -15px;
  top: -15px;
  font-family: Georgia, serif;
  opacity: 0.7;
}

.author {
  text-align: right;
  font-weight: bold;
}

@media (max-width: 1024px) {
  .testimonial-grid {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
}

@media (max-width: 768px) {
  .testimonial-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .testimonial {
    padding: 20px;
    margin-bottom: 15px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    transition: transform 0.25s ease, background-color 0.25s ease, box-shadow 0.25s ease;
    border: 1px solid #e8f4fc;
  }
  
  .testimonial:active {
    transform: scale(0.98);
    background-color: #fafeff;
  }
  
  .testimonials {
    margin: 40px 0;
    padding: 25px 20px;
    border-radius: 8px;
  }
  
  .stars {
    font-size: 1.2rem;
    margin-bottom: 10px;
  }
  
  .quote {
    font-size: 1rem;
    margin-bottom: 10px;
  }
  
  .quote::before {
    font-size: 2rem;
    left: -10px;
    top: -10px;
  }
  
  .author {
    font-size: 0.9rem;
  }
  
  .testimonials h3 {
    font-size: 1.5rem;
    margin: 0 0 20px;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .testimonials {
    margin: 30px 0;
    padding: 20px 15px;
  }
  
  .testimonial {
    padding: 15px;
    border-radius: 6px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    transition: transform 0.2s ease, background-color 0.2s ease;
    border: 1px solid #e8f4fc;
    margin-bottom: 10px;
  }
  
  .testimonial:active {
    transform: scale(0.97);
    background-color: #f7fcff;
  }
  
  .stars {
    font-size: 1.1rem;
  }
  
  .quote {
    font-size: 0.95rem;
    line-height: 1.5;
  }
  
  .quote::before {
    font-size: 1.8rem;
    left: -8px;
    top: -8px;
    opacity: 0.5;
  }
  
  .author {
    font-size: 0.85rem;
  }
  
  .testimonials h3 {
    font-size: 1.4rem;
    margin: 0 0 15px;
  }
  
  .testimonial-grid {
    gap: 15px;
  }
}
</style> 